
// Angular
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

// 3rdparty
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { combineLatest, map, Observable, Subscription } from 'rxjs';
// Hostware
import { RequestResult } from '@app/core/dto/RequestResult';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { TopBarManagerService } from '@app/core/services/topbar-manager.service';
import { CleaningType } from '@app/kip/dto/CleaningType';
import { SubscriberParameter } from '@app/kip/dto/SubscriberParameter';
import { SubscriberParamTypes } from '@app/kip/enums/SubscriberParamTypes';
import { CleaningTypeService } from '@app/kip/services/cleaning-type.service';
import { CrudMessagesService } from '@app/kip/services/crud-messages.service';
import { SubscriberParameterService } from '@app/kip/services/subscriber-parameter.service';
import { HwAlertService } from '@globalshared/hw-alert-component/src/lib';
import { TranslateService } from '@ngx-translate/core';
import { Socket } from 'ngx-socket-io';
import { v4 as uuidv4 } from 'uuid';


@AutoUnsubscribe()
@Component({
  selector: 'subscriber-parameter-editor',
  templateUrl: './subscriber-parameter-editor.component.html',
  styleUrls: ['./subscriber-parameter-editor.component.scss']
})
export class SubscriberParameterEditorComponent implements OnInit, OnDestroy {

  editorForm: FormGroup;

  hotelUnitChanged$: Subscription;
  updateAll$: Subscription;
  allCleaningTypes: CleaningType[] = [];
  additionalTaskTypes: CleaningType[] = [];
  allSubscriberParameters: SubscriberParameter[] = [];

  userinfo = this.sessionStorageService.getUserInfo()

  constructor(
    private sessionStorageService: SessionStorageService,
    private topBarManagerService: TopBarManagerService,
    private cleaningTypeService: CleaningTypeService,
    private hwAlertService: HwAlertService,
    private fb: FormBuilder,
    private translate: TranslateService,
    private subsParamService: SubscriberParameterService,
    private crudMessageService: CrudMessagesService,
    private socket: Socket
  ) {

    this.editorForm = fb.group({
      'fBaseAmmenityType': new FormControl(''),
      'fSendNotifications': new FormControl(''),
      'fFroDateFromWeb': new FormControl(''),
      'fIgnoreMultihotel': new FormControl(''),
      'fShowPerformance': new FormControl(''),
      'fExtraRightsForInferiors': new FormControl(''),
      'fCleaningWageCosts': new FormControl(1),
      'fChatVisibility': new FormControl(''),
      'fAdditionalTaskType': new FormControl(''),
      'fMaterialConsumption': new FormControl(''),
      'fParentHotel': new FormControl({ value: '', disabled: true }),
      'fTaskShareMulti' : new FormControl(''),
      'fMinibarForCleaner' : new FormControl(''),
    });

  }


  //#region =============== Angular Lifecyle events ============================================================================
  ngOnInit() {
    this.topBarManagerService.HideRootHotel.emit();
    this.hotelUnitChanged$ = this.topBarManagerService.hotelUnitChanged.subscribe(event => {
      this.init();
    })
    this.init();
  }
  ngOnDestroy(): void {
    this.hotelUnitChanged$?.unsubscribe();
    this.updateAll$?.unsubscribe();
  }

  //#endregion =================================================================================================================

  //#region =============== List event hadlers   ===============================================================================
  //#endregion =================================================================================================================

  //#region =============== Form events ========================================================================================
  //#endregion =================================================================================================================

  //#region =============== Dialog events ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Validation    ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Functions  =========================================================================================
  init() {
    combineLatest([this.loadAllCleaningTypes(), this.loadSubscriberParameters()]).subscribe(([resCleaningTypes, resSubscriberParameters]) => {
      this.allCleaningTypes = resCleaningTypes.Data as Array<CleaningType>;
      this.additionalTaskTypes = JSON.parse(JSON.stringify(resCleaningTypes.Data)) as Array<CleaningType>;
      const notUsed: CleaningType = new CleaningType();
      notUsed.TypeId = -1;
      notUsed.TypeName = this.translate.instant("common.not_set");
      this.allCleaningTypes.splice(0, 0, notUsed)
      this.additionalTaskTypes.splice(0, 0, notUsed)
      this.allSubscriberParameters = resSubscriberParameters as Array<SubscriberParameter>;
      const baseAmmenityType = this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.BASE_AMMENITY_TYPE).Param_Int_Value;
      const sendNotifications = this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.SEND_NOTIFICATIONS).Param_Int_Value;
      const froDateFromWeb = this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.FRO_DATE_FROM_WEB).Param_Int_Value;
      const ignoreMultiHotel = this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.IGNORE_MULTI_HOTEL).Param_Int_Value;
      const showPerfomance = this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.SHOW_PERFORMANCE).Param_Int_Value;
      const extraRightsForInferiors = this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.EXTRA_RIGHTS).Param_Int_Value;
      const cleaningWageCosts = this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.CLEANING_WAGE_COSTS).Param_Int_Value;
      const parentHotel = this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.PARENT_HOTEL).Param_String_Value;
      const chatVisibility = this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.CHAT_VISIBILITY).Param_Int_Value;
      const additionalTaskType = this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.ADDITIONAL_TASK).Param_Int_Value;
      const mterialConsumption = this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.MATERIAL_CONSUMPTION).Param_Int_Value;
      const taskShareMulti = this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.TASK_SHARE_MULTI).Param_Int_Value;
      const minibarForCleaner = this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.MINIBAR_FOR_CLEANER).Param_Int_Value;


      this.editorForm.controls["fBaseAmmenityType"].setValue(baseAmmenityType);
      this.editorForm.controls["fSendNotifications"].patchValue(sendNotifications == 1 ? true : false);
      this.editorForm.controls["fFroDateFromWeb"].patchValue(froDateFromWeb == 1 ? true : false);
      this.editorForm.controls["fIgnoreMultihotel"].patchValue(ignoreMultiHotel == 1 ? true : false);
      this.editorForm.controls["fShowPerformance"].patchValue(showPerfomance == 1 ? true : false);
      this.editorForm.controls["fExtraRightsForInferiors"].patchValue(extraRightsForInferiors == 1 ? true : false);
      this.editorForm.controls["fCleaningWageCosts"].patchValue(cleaningWageCosts);
      this.editorForm.controls["fChatVisibility"].patchValue(chatVisibility == 1 ? true : false);
      this.editorForm.controls["fMaterialConsumption"].patchValue(mterialConsumption == 1 ? true : false);
      this.editorForm.controls["fParentHotel"].patchValue(parentHotel == '' ? this.translate.instant('common.no_selected_item') : parentHotel);
      this.editorForm.controls["fAdditionalTaskType"].setValue(additionalTaskType);
      this.editorForm.controls["fTaskShareMulti"].patchValue(taskShareMulti == 1 ? true : false);
      this.editorForm.controls["fMinibarForCleaner"].patchValue(minibarForCleaner == 1 ? true : false);
    })

  }


  loadAllCleaningTypes(): Observable<any> {
    return this.cleaningTypeService.loadAll(this.sessionStorageService.getSelectedUnit(), this.sessionStorageService.getSelectedHotelId()).pipe(map((result) => {
      return result;
    }))
  }

  loadSubscriberParameters(): Observable<any> {
    return this.subsParamService.loadAll(this.sessionStorageService.getSelectedUnit(), this.sessionStorageService.getSelectedHotelId()).pipe(map((result) => {
      return result;
    }))
  }

  updateAll() {
    this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.BASE_AMMENITY_TYPE).Param_Int_Value
      = parseInt(this.editorForm.controls["fBaseAmmenityType"].value);


    this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.SEND_NOTIFICATIONS).Param_Int_Value
      = this.editorForm.controls["fSendNotifications"].value === true ? 1 : 0;

    this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.FRO_DATE_FROM_WEB).Param_Int_Value
      = this.editorForm.controls["fFroDateFromWeb"].value === true ? 1 : 0;

    this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.IGNORE_MULTI_HOTEL).Param_Int_Value
      = this.editorForm.controls["fIgnoreMultihotel"].value === true ? 1 : 0;

    this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.SHOW_PERFORMANCE).Param_Int_Value
      = this.editorForm.controls["fShowPerformance"].value === true ? 1 : 0;

    this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.EXTRA_RIGHTS).Param_Int_Value
      = this.editorForm.controls["fExtraRightsForInferiors"].value === true ? 1 : 0;

    this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.CLEANING_WAGE_COSTS).Param_Int_Value
      = this.editorForm.controls["fCleaningWageCosts"].value;

    this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.CHAT_VISIBILITY).Param_Int_Value
      = this.editorForm.controls["fChatVisibility"].value === true ? 1 : 0;

    this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.ADDITIONAL_TASK).Param_Int_Value
      = parseInt(this.editorForm.controls["fAdditionalTaskType"].value);

    this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.MATERIAL_CONSUMPTION).Param_Int_Value
      = this.editorForm.controls["fMaterialConsumption"].value === true ? 1 : 0;

    this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.TASK_SHARE_MULTI).Param_Int_Value
      = this.editorForm.controls["fTaskShareMulti"].value === true ? 1 : 0;

    this.allSubscriberParameters.find(item => item.Param_Typecode == SubscriberParamTypes.MINIBAR_FOR_CLEANER).Param_Int_Value
      = this.editorForm.controls["fMinibarForCleaner"].value === true ? 1 : 0;

    this.sessionStorageService.ShareEnabled = parseInt(this.editorForm.controls["fAdditionalTaskType"].value) == -1 ? false : true


    this.updateAll$ = this.subsParamService.updateAll(this.allSubscriberParameters).subscribe(result => {
      const res = result as RequestResult;
      this.crudMessageService.showAddOrEditMessage(res)
    })

  }

  submit() {
    let isChatVisible = this.editorForm.controls["fChatVisibility"].value

    if (isChatVisible) {
      let housekeeping = this.createRoom("housekeeping")
      let karbantarto = this.createRoom("karbantarto")
      let all = this.createRoom("all")


      this.socket.emit('createChatFromFrohok', { housekeeping, karbantarto, all })
    }

    this.updateAll();
  }
  //#endregion =================================================================================================================

  createRoom(name: string): Object {
    let baseName = this.userinfo.SubscriberTree.SubscriberCode + "-" + this.userinfo.SubscriberTree.Htlnum

    return {
      room_uuid: uuidv4(),
      room_name: baseName + "-" + name,
      room_type: 'FROhok',
      subscriber: this.userinfo.SubscriberTree.SubscriberCode,
      hotel_id: this.userinfo.SubscriberTree.Htlnum,
    }
  }
}
